<template>
	<div>
		<el-form ref="form" :model="form" :rules="rules" size="small" label-position="right" label-width="120px">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="姓名" prop="personName">
						<el-input v-model.trim="form.personName"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="身份证号" prop="idCard">
						<el-input v-model.trim="form.idCard"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="职称" prop="certificateName">
						<el-cascader v-model="form.certificateName" :options="dictionarys.zcList" :props="zcDictProps"></el-cascader>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="职称等级" prop="professionalLevel">
						<el-select v-model.trim="form.professionalLevel" style="width: 100%;">
							<el-option
								v-for="item in dictionarys.zcdjList"
								:key="item.dictcode"
								:label="item.dictionaryValues"
								:value="item.dictionaryValues"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="职称专业" prop="professionalProject">
						<el-select v-model.trim="form.professionalProject" style="width: 100%;" multiple collapse-tags>
							<el-option
								v-for="item in dictionarys.zczyList"
								:key="item.dictcode"
								:label="item.dictionaryValues"
								:value="item.dictionaryValues"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="申报资质类别" prop="zzCode">
						<el-select v-model.trim="form.zzCode" style="width: 100%;" multiple collapse-tags filterable>
							<el-option
								v-for="item in dictionarys.zzCodeList"
								:key="item.dictcode"
								:label="item.dictionaryValues"
								:value="item.dictcode"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import { validateIdCard } from '@/utils/jr-validate'
	import { queryCommonDictionary } from '@/api/dictionary/index'
	import { handleTree } from '@/utils'

	/**
	 * 职称人员表单组件
	 */
	export default {
		name: 'ProfessionalPersonnel',
		components: {},
		data() {
			return {
				form: {
					// 主键
					id: '',
					// 姓名
					personName: '',
					// 证件号码
					idCard: '',
					// 职称
					certificateName: [],
					// 职称
					certificateSubName: '',
					// 职称专业
					professionalProject: [],
					// 申报资质类别
					zzCode: '',
					// 职称等级
					professionalLevel: ''
				},
				rules: {
					personName: { required: true, message: '请输入', trigger: 'blur' },
					idCard: [
						{ required: true, message: '请输入', trigger: 'blur' },
						{ validator: validateIdCard, trigger: 'blur' }
					],
					certificateName: { required: true, message: '请输入', trigger: 'change' },
					professionalProject: { required: true, message: '请输入', trigger: 'change' },
					zzCode: { required: true, message: '请输入', trigger: 'blur' },
					professionalLevel: { required: true, message: '请输入', trigger: 'change' }
				},
				// 字典集合
				dictionarys: {
					// 职称等级字典
					zcdjList: [
						{
							dictionaryValues: '高级',
							dictcode: '高级'
						},
						{
							dictionaryValues: '中级',
							dictcode: '中级'
						}
					],
					// 职称专业字典
					zczyList: [],
					// 职称字典
					zcList: [],
					// 资质类别字典
					zzCodeList: []
				},
				// 职称级联选择器配置项
				zcDictProps: {
					children: 'children',
					label: 'dictionaryValues',
					value: 'dictionaryValues'
				}
			}
		},
		created() {},
		mounted() {
			this.handleInitDictionary()
		},
		methods: {
			handleInitDictionary() {
				// 获取职称专业字典
				queryCommonDictionary({ dictionaryId: '7', cxType: '3' }).then(res => {
					this.dictionarys.zczyList = res.data
				})
				// 获取职称字典
				queryCommonDictionary({ dictionaryId: '5', cxType: '3' }).then(res => {
					this.dictionarys.zcList = handleTree(res.data, 'id', 'pid', 'children')
				})

				// 申报资质类别字典
				const params = {
					// 资质等级
					dictionaryId: '1',
					// 查询全部资质
					cxType: '2'
				}
				queryCommonDictionary(params)
					.then(response => {
						this.qualificationLoading = false
						const { data } = response

						if (data && data.length) {
							// 遍历数据给每一个子项添加selected属性
							data.forEach(item => {
								if (item.collection && Array.isArray(item.collection)) {
									item.collection.forEach(subItem => {
										subItem.selected = false
									})
								}
							})
							// zzCodeList为对象数组，现在要取出其中一项的code为107的
							this.dictionarys.zzCodeList = data.filter(item => item.code === '107')[0].collection
						}
					})
					.catch(error => {
						this.dictionarys.zzCodeList = []
					})
			},
			// 表单保存操作（每个列表对应的表单组件必须添加此方法，且必须同名）
			handleSaveInfo() {
				return new Promise(resolve => {
					this.$refs.form.validate(valid => {
						if (valid) {
							resolve(this.form)
						}
					})
				})
			}
		}
	}
</script>

<style scoped></style>
